<template>
  <div id="app">
    <div class="content">
      <Login v-if="view === 'login'" />
      <Home v-else-if="user && view === 'home'" :user="user" />
      <button v-if="user" class="sign-out" @click="onLogout">
        <icon icon="sign-out-alt" />
      </button>
    </div>
    <div class="footer">
      Made by
      <a target="_blank" href="https://www.twitter.com/brecii">Breci</a>. Need
      some help? Join my
      <a target="_blank" href="https://discord.gg/rDYBfJb">Discord</a>!
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { TOKEN_ITEM, STATE_ITEM, CLIENT_ID } from "./settings";
import Home from "./views/Home";
import Login from "./views/Login";

export default {
  name: "App",
  components: { Home, Login },
  data() {
    return {
      authorized: false,
      extensions: [],
      view: "login",
      user: ""
    };
  },
  methods: {
    onLogout() {
      localStorage.removeItem(TOKEN_ITEM);
      this.view = "login";
      this.user = "";
    }
  },
  async beforeMount() {
    if (location.hash.length > 1 || localStorage.getItem(TOKEN_ITEM)) {
      const urlParams = new URLSearchParams(window.location.hash.substr(1));

      let token = localStorage.getItem(TOKEN_ITEM);
      if (urlParams.get("state") === localStorage.getItem(STATE_ITEM)) {
        token = urlParams.get("access_token");
        localStorage.setItem(TOKEN_ITEM, token);
        localStorage.removeItem(STATE_ITEM);
      }

      const config = {
        method: "GET",
        headers: {
          Authorization: `OAuth ${token}`
        }
      };

      await fetch("https://id.twitch.tv/oauth2/validate", config)
        .then(async () => {
          const user = await axios
            .get("https://api.twitch.tv/helix/users", {
              headers: {
                Authorization: `Bearer ${token}`,
                "Client-ID": CLIENT_ID
              }
            })
            .then(response => response.data.data[0]);
          this.user = user.id;
        })
        .then(async () => {
          this.view = "home";
          location.hash = "";
        })
        .catch(() => {
          const state = (Date.now() * Math.random()).toString();
          localStorage.setItem(STATE_ITEM, state);
          window.location = `https://id.twitch.tv/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${process.env.VUE_APP_REDIRECT_URL}&response_type=token&state=${state}`;
        });
    } else if (localStorage.getItem(TOKEN_ITEM)) {
      const config = {
        method: "GET",
        headers: {
          Authorization: `OAuth ${localStorage.getItem(TOKEN_ITEM)}`,
          "Client-ID": CLIENT_ID
        }
      };

      axios
        .get("https://id.twitch.tv/oauth2/validate", config)
        .then(() => {
          this.view = "home";
        })
        .catch(e => {
          console.error(e);
          const state = (Date.now() * Math.random()).toString();
          localStorage.setItem(STATE_ITEM, state);
          window.location = `https://id.twitch.tv/oauth2/authorize?client_id=${CLIENT_ID}&redirect_uri=${process.env.VUE_APP_REDIRECT_URL}&response_type=token&state=${state}`;
        });
    } else {
      this.view = "login";
    }
  },
  watch: {
    async view(newView) {
      if (newView === "home") {
        const user = await axios
          .get("https://api.twitch.tv/helix/users", {
            headers: {
              Authorization: `Bearer ${localStorage.getItem(TOKEN_ITEM)}`,
              "Client-ID": CLIENT_ID
            }
          })
          .then(response => response.data.data[0])
          .catch(e => console.error(e));
        this.user = user.id;
      }
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
}

.sign-out {
  position: absolute;
  right: 0;
  top: 0;
  padding: 1rem;
  font-size: 1.5rem;
  cursor: pointer;
}

.content {
  flex: 1;
}

.footer {
  @apply w-full bg-gray-400 text-center text-sm text-gray-900 py-1;
}

.footer a {
  @apply border border-0 border-purple-500 border-b cursor-pointer font-semibold;
}
html,
body {
  min-height: 100%;
  height: 100%;
}
</style>
